export default [
  {
    url: "/",
    name: "Overview",
    slug: "overview",
    icon: "HomeIcon",
  },
  {
    url: "/credit-cards",
    name: "Credit Cards",
    slug: "Credit Cards",
    icon: "CreditCardIcon",
    submenu: [
      {
        url: '/credit-cards/view-cards',
        name: "View Cards",
        slug: "view cards",
        i18n: "view cards",
      },
      {
        url: '/credit-cards/view-cards/v2',
        name: "View Cards v2",
        slug: "view cards v2",
        i18n: "view cards v2",
      },
      {
        url: '/credit-cards/issuers/v2',
        name: "Issuers v2",
        slug: "Issuers v2",
        i18n: "Issuers v2",
      },
      {
        url: '/credit-cards/pending-approvals',
        name: "Pending Approval",
        slug: "pending approvals",
        i18n: "pending approvals",
      },
      {
        url: '/credit-cards/offers',
        name: "Offers",
        slug: "offers",
        i18n: "offers",
      },
      {
        url: '/credit-cards/point-categories',
        name: "Point Groups",
        slug: "point-categories",
        i18n: "point categories",
      },
      {
        url: '/credit-cards/cheatsheet',
        name: "Cheat Sheet",
        slug: "cheatsheet",
        i18n: "cheatsheet",
      },
      {
        url: '/credit-cards/bonuscategories',
        name: "Bonus Categories",
        slug: "Bonuscategories",
        i18n: "Bonuscategories",
      },
    ]
  },
  {
    url: '/promos',
    name: "Promos",
    slug: "promos",
    icon: require('@/assets/images/coupon@2x.png'),
    submenu: [
      {
        url: '/promos',
        name: "Admin Promos",
        slug: "Admin Promos",
        i18n: "Admin Promos",
      },
      {
        url: '/useraddedpromos',
        name: "User Promos",
        slug: "useraddedpromos",
        i18n: "useraddedpromos",
      },
    ]
  },
  {
    url: "/accounts",
    name: "Users",
    slug: "accounts",
    icon: "UsersIcon",
  },
  {
    url: "/messages",
    name: "Messages",
    slug: "messages",
    icon: "MailIcon",
  },
  {
    url: "/manage-admins",
    name: "Manage Admins",
    slug: "manage admins",
    icon: "UserIcon",
  },
  {
    url: "/settings",
    name: "Profile",
    slug: "settings",
    icon: "SettingsIcon",
  },
]
